import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { ModalService } from '../../../core/services/modal.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { Grid } from '../../../core/components/grid/grid.model';

@Component({
  selector: 'tt-project-invoicing',
  templateUrl: './project-invoicing.component.html',
  styleUrls: ['./project-invoicing.component.css']
})
export class ProjectInvoicingComponent implements OnInit {
    projectKeyno;

    invoiceCustNo;

    public menu?: Menu;

    public grid?: GridOptions;

    public gridBase?: GridOptions;

    public gridInvoiced?: GridOptions;

    public projectKeynoAndNameButtons: FormButton[] = [{ id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'projectmenu', gotoParms: () => this.menu!.project_keyno ?? '' }];

    public custNoAndNameButtons: FormButton[] = [{ id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'customersmenu', gotoParms: () => this.menu!.invoice_cust_no ?? '' }];

    public saving = false;

    public creatingInvoice = false;

    public settingNot = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.projectKeyno = this.stateService.getStateParams()['project_keyno'];
        this.invoiceCustNo = this.stateService.getStateParams()['invoice_cust_no'];
    }

    private async loadMenu() {
        if (!!this.projectKeyno && !!this.invoiceCustNo) {
            this.menu = (await this.datatask.Post(2198, {
                project_keyno: this.projectKeyno,
                invoice_cust_no: this.invoiceCustNo
            }))[0];
        }
    }

    private loadGrid() {
        if (!this.menu) return;

        if (!this.grid) {
            this.grid = new Grid().setRememberId(this.menu.view_id).setLoadDataFunction({ method: this.menu.p2_datatask_keyno, parameters: () => this.menu }).setKendoConfig({ height: '100%' }).setToolbar({ wrapping: true });
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    private loadGridBase() {
        if (!this.menu) return;

        if (!this.gridBase) {
            this.gridBase = new Grid().setRememberId(this.menu.view_id_base).setLoadDataFunction({ method: this.menu.p2_datatask_keyno_base, parameters: () => this.menu }).setKendoConfig({ height: '100%' }).setToolbar({ wrapping: true });
        } else {
            this.gridBase?.gridfunc?.read();
        }
    }

    private loadGridInvoiced() {
        if (!this.menu) return;

        if (!this.gridInvoiced) {
            this.gridInvoiced = new Grid().setRememberId(this.menu.view_id_invoiced).setLoadDataFunction({ method: this.menu.p2_datatask_keyno_invoiced, parameters: () => this.menu }).setKendoConfig({ height: '100%' }).setToolbar({ wrapping: true });
        } else {
            this.gridInvoiced?.gridfunc?.read();
        }
    }

    public async saveChanges() {
        if (!!this.menu) {
            try {
                this.saving = true;

                const selectedItems = (this.grid?.gridfunc?.getAllRows() ?? []).filter((row) => row['is_selected'] === true).map((row) => ({
                    powtime_keyno: row['powtime_keyno'],
                    is_selected: row['is_selected']
                }));

                const mergeObj = {
                    ...this.menu,
                    records: selectedItems
                }

                const response = (await this.datatask.Post(2204, mergeObj))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.loadGridBase();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    public async createChanges() {
        if (!!this.menu) {
            try {
                this.creatingInvoice = true;

                const selectedItems = (this.grid?.gridfunc?.getAllRows() ?? []).filter((row) => row['is_selected'] === true).map((row) => ({
                    powtime_keyno: row['powtime_keyno'],
                    is_selected: row['is_selected']
                }));

                const mergeObj = {
                    ...this.menu,
                    records: selectedItems
                }

                const response = (await this.datatask.Post(2200, mergeObj))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.creatingInvoice = false;
            }
        }
    }

    public async setNotValues() {
        if (!!this.menu) {
            try {
                this.settingNot = true;

                const setNotConfirmed = await this.modal.openConfirmDialog({
                    title: 'confirm_title',
                    translateMessage: true,
                    message: 'confirm_no_invoicing_on_selected_rows',
                    type: 'danger'
                });

                if (setNotConfirmed) {
                    const selectedItems = (this.grid?.gridfunc?.getAllRows() ?? []).filter((row) => row['is_selected'] === true).map((row) => ({
                        powtime_keyno: row['powtime_keyno'],
                        is_selected: row['is_selected']
                    }));

                    const mergeObj = {
                        ...this.menu,
                        records: selectedItems
                    }

                    const response = (await this.datatask.Post(2201, mergeObj))[0];

                    if (response?.errorcode !== '0') {
                        this.modal.show({
                            type: 'warning',
                            title: 'error',
                            message: response.errormessage
                        });
                    } else {
                        this.loadGrid();
                    }
                }
            } finally {
                this.settingNot = false;
            }
        }
    }

    private async init() {
        await this.loadMenu();
        this.loadGrid();
        this.loadGridBase();
        this.loadGridInvoiced();
    }

    ngOnInit() {
        this.init();
    }
}

interface Menu {
    businessco_no: string;
    businessco_companyname: string;
    project_keyno: string;
    project_keyno_and_name: string;
    invoice_cust_no: string;
    cust_no_and_name: string;
    view_id: string;
    p2_datatask_keyno: number;
    invoice_date: string;
    p2_datatask_keyno_base: number;
    view_id_base: string;
    p2_datatask_keyno_invoiced: number;
    view_id_invoiced: string;
    selected_tab: string;
}
